import { shallowEqual, type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import type Context from '@alltrails/types/Context';
import context from '@alltrails/context/slices/contextSlice';
import type Feature from '@alltrails/types/Feature';
import features from '@alltrails/features/slices/features';
import userConnections from '@alltrails/redux/slices/userConnections';
import userConnectionLists from '@alltrails/redux/slices/userConnectionLists';
import { baseApi } from '@alltrails/redux-helpers';
import reviewsSearchFilters from './slices/reviewsSearchFilters';

export type PreloadedState = {
  context: Context;
  features?: Feature[];
};

export const reducer = {
  context,
  userConnections,
  userConnectionLists,
  features,
  reviewsSearchFilters,
  [baseApi.reducerPath]: baseApi.reducer
};

export const buildStore = (preloadedState?: Partial<PreloadedState>) =>
  configureStore({ reducer, preloadedState, middleware: getDefaultMiddleware => getDefaultMiddleware().concat(baseApi.middleware) });

export type AppStore = ReturnType<typeof buildStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<AppStore['getState']>;

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = (selector: (state: RootState) => any) =>
  useSelector<RootState, any>(selector, shallowEqual);
